import React from "react"
import { useRoutes } from "react-router-dom"
import ProtectedRoute from "./ProtectedRoute"

interface ProtectedRoutesProps {
	routes: any[]
}

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ routes }) => {
	const guardedRoutes = routes.map((route) => {
		if (!route.protected) {
			return route
		}

		return {
			...route,
			element: <ProtectedRoute>{route.element}</ProtectedRoute>,
		}
	})

	return useRoutes(guardedRoutes)
}

export default ProtectedRoutes
